var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5131 8.82019C20.164 9.47106 20.164 10.5263 19.5131 11.1772L12.3583 18.332H31.668C32.5884 18.332 33.3346 19.0782 33.3346 19.9987C33.3346 20.9192 32.5884 21.6654 31.668 21.6654H12.3583L19.5131 28.8202C20.164 29.4711 20.164 30.5263 19.5131 31.1772C18.8623 31.8281 17.807 31.8281 17.1561 31.1772L7.15612 21.1772C6.84356 20.8646 6.66797 20.4407 6.66797 19.9987C6.66797 19.5567 6.84356 19.1327 7.15612 18.8202L17.1561 8.82019C17.807 8.16931 18.8623 8.16931 19.5131 8.82019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.b2dcd64def36f58a2cc451856f6a5d68.svg";
export { ForwardRef as ReactComponent };